(function () {
  const DESKTOP_MEDIA_QUERY = "(min-width: 750px)";

  const createSwiperForContainer = (container) => {
    if (!container || container.swiper || typeof Swiper === "undefined") return;

    new Swiper(container, {
      slidesPerView: "auto",
      spaceBetween: 16,
      mousewheel: {
        forceToAxis: true,
        sensitivity: 1,
        releaseOnEdges: true
      },
      observer: true,
      observeParents: true,
      breakpoints: {
        750: { spaceBetween: 8 },
        990: { spaceBetween: 8 },
        1440: { spaceBetween: 16 }
      }
    });
  };

  const destroyAllSwipers = (scope) => {
    scope.querySelectorAll(".Index_tab_featured_collection_slider").forEach((slider) => {
      if (slider.swiper) {
        slider.swiper.destroy(true, true);
      }
    });
  };

  const initSection = (section) => {
    const collectionTabs = section.querySelectorAll(".Index_featrued_collection_single_tab");
    const collectionTabSliders = section.querySelectorAll(".Index_tab_featured_collection_slider");
    let isInitialLoad = true;

    const setActiveCollectionTab = (activeTab) => {
      if (!activeTab) return;

      collectionTabs.forEach((tab) => tab.classList.remove("active"));
      activeTab.classList.add("active");

      const tabHandle = activeTab.dataset.collectionTab;

      collectionTabSliders.forEach((slider) => {
        const isActiveSlider = slider.dataset.collectionSlider === tabHandle;
        slider.classList.toggle("show", isActiveSlider);

        if (!isActiveSlider) return;

        if (window.matchMedia(DESKTOP_MEDIA_QUERY).matches) {
          createSwiperForContainer(slider);
        }

        if (slider.swiper) {
          slider.swiper.update();
        }
      });
    };

    collectionTabs.forEach((tab) => {
      if (tab.dataset.tabsInitialized === "true") return;

      tab.addEventListener("click", function () {
        setActiveCollectionTab(this);

        if (!isInitialLoad) {
          this.scrollIntoView({
            behavior: "smooth",
            inline: "center",
            block: "nearest"
          });
        }
      });

      tab.dataset.tabsInitialized = "true";
    });

    const firstTab = section.querySelector(".Index_featrued_collection_single_tab:first-child");
    if (firstTab) {
      setActiveCollectionTab(firstTab);
    }

    isInitialLoad = false;

    if (section.dataset.resizeBound !== "true") {
      window.addEventListener("resize", () => {
        if (window.matchMedia(DESKTOP_MEDIA_QUERY).matches) {
          const activeTab = section.querySelector(".Index_featrued_collection_single_tab.active") || firstTab;
          setActiveCollectionTab(activeTab);
        } else {
          destroyAllSwipers(section);
        }
      });
      section.dataset.resizeBound = "true";
    }
  };

  const initAllSections = () => {
    const sections = document.querySelectorAll(".Index_tab_featured_collection_main");

    if (!("IntersectionObserver" in window)) {
      sections.forEach(initSection);
      return;
    }

    const observer = new IntersectionObserver(
      (entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          initSection(entry.target);
          currentObserver.unobserve(entry.target);
        });
      },
      {
        rootMargin: "300px 0px",
        threshold: 0.01
      }
    );

    sections.forEach((section) => observer.observe(section));
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAllSections);
  } else {
    initAllSections();
  }

  document.addEventListener("shopify:section:load", initAllSections);
})();